import { PREVIEW_ANIMATE } from './types';

export const previewAnimate = state => ({
    type: PREVIEW_ANIMATE,
    payload: {
        animate: state
    }
});
